// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__SdFQl","buttons":"SendReceipts_buttons__lgWX8","email":"SendReceipts_email__1TXZg","bookApptTitle":"SendReceipts_bookApptTitle__Z2hoC"};